/* Black Friday — floating claim pill. Shows while the offer bar is off screen,
   hides when it is in view. Duplicated 2.0 product only.
   Also hides the theme's sticky add-to-cart bar on this page, because the pill
   sits in the same place. */
(function () {
  'use strict';
  if (location.pathname.indexOf('breathefree-2-0-resistance-necklace-early-black-friday') === -1) return;

  /* Rolling 24-hour deadline: the next local midnight, so the countdown
     restarts by itself every day and matches the announcement bar. */
  function endOfDay() { var e = new Date(); e.setHours(24, 0, 0, 0); return e.getTime(); }

  var CSS = [
    /* kill the theme's sticky ATC bar — the claim pill replaces it here */
    '[id^="shopify-section-template--"][id$="__sticky"]{display:none!important}',
    '[id^="shopify-section-template--"][id$="__sticky"] .sticky{display:none!important}',
    '.ebff{position:fixed;left:50%;bottom:14px;z-index:40;width:calc(100% - 24px);max-width:520px;',
      'display:flex;align-items:center;justify-content:space-between;gap:10px;',
      'padding:6px 6px 6px 16px;border-radius:999px;',
      'background:linear-gradient(90deg,#160d0f,#000);border:1.5px solid #c8102e;',
      'box-shadow:0 14px 34px -12px rgba(200,16,46,.7);color:#fff;',
      'font-family:Poppins,var(--font-body-family,sans-serif);',
      'transform:translate(-50%,160%);opacity:0;pointer-events:none;',
      'transition:transform .45s cubic-bezier(.2,.9,.3,1.2),opacity .3s ease}',
    '.ebff.is-on{transform:translate(-50%,0);opacity:1;pointer-events:auto}',
    'body.overflow-hidden .ebff,body.overflow-hidden-mobile .ebff{opacity:0!important;pointer-events:none!important}',
    '.ebff__t{display:flex;align-items:center;gap:9px;min-width:0;font-size:13px;font-weight:700;line-height:1.25}',
    '.ebff__i{flex:none;font-size:16px;line-height:1}',
    '.ebff__time{color:#ff4d61;font-variant-numeric:tabular-nums;font-weight:800;white-space:nowrap}',
    '.ebff__b{flex:none;border:0;cursor:pointer;border-radius:999px;padding:9px 16px;',
      'background:linear-gradient(180deg,#e2203a,#a50c23);color:#fff;font:inherit;font-size:12.5px;',
      'font-weight:800;letter-spacing:.07em;text-transform:uppercase;white-space:nowrap}',
    '@media(max-width:749px){.ebff{bottom:10px;padding-left:13px}.ebff__t{font-size:11.5px;gap:7px}.ebff__b{padding:8px 12px;font-size:11px}}',
    '@media(prefers-reduced-motion:reduce){.ebff{transition:none}}'
  ].join('');

  var st = document.createElement('style');
  st.textContent = CSS;
  (document.head || document.documentElement).appendChild(st);

  /* belt and braces: the sticky section is injected late by the theme */
  function killSticky() {
    var nodes = document.querySelectorAll('[id^="shopify-section-template--"][id$="__sticky"]');
    for (var i = 0; i < nodes.length; i++) nodes[i].style.setProperty('display', 'none', 'important');
  }

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function build() {
    if (st.parentNode !== document.body && document.body) document.body.appendChild(st);
    killSticky();
    if (document.querySelector('.ebff')) return;

    var el = document.createElement('div');
    el.className = 'ebff';
    el.innerHTML =
      '<span class="ebff__t"><span class="ebff__i">⚡</span>' +
        '<span>35% off + 2nd flavor free ends in <span class="ebff__time" data-ebff-t>--</span></span></span>' +
      '<button type="button" class="ebff__b">Claim ↑</button>';
    document.body.appendChild(el);

    var target = document.querySelector('.rsb .ebf') || document.querySelector('[data-rsb]');
    el.querySelector('.ebff__b').addEventListener('click', function () {
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });

    function tick() {
      var left = Math.max(0, endOfDay() - Date.now());
      var q = Math.floor(left / 1000);
      var h = Math.floor(q / 3600), m = Math.floor((q % 3600) / 60), s = q % 60;
      var t = el.querySelector('[data-ebff-t]');
      if (t) t.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
    }
    tick();
    setInterval(tick, 1000);

    if (target && 'IntersectionObserver' in window) {
      var ready = false;
      setTimeout(function () { ready = true; }, 1200);
      new IntersectionObserver(function (entries) {
        var off = !entries[0].isIntersecting;
        var apply = function () { el.classList.toggle('is-on', off); };
        ready ? apply() : setTimeout(apply, 1200);
      }, { threshold: 0 }).observe(target);
    } else {
      setTimeout(function () { el.classList.add('is-on'); }, 1500);
    }
  }

  /* the offer bar is injected by bf-early.js, so wait for it */
  function start() {
    killSticky();
    setTimeout(killSticky, 600);
    setTimeout(killSticky, 2000);
    if (document.querySelector('.rsb .ebf')) { build(); return; }
    var n = 0;
    var iv = setInterval(function () {
      if (document.querySelector('.rsb .ebf') || ++n > 40) { clearInterval(iv); build(); }
    }, 150);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();